export default "__VITE_ASSET__97a2f866__"